module.exports = __webpack_public_path__ + "media/student_v2/assets/images/icon_alert_white-b5a316e649fba2782859309de707d7af.svg";